import { ReactNode } from 'react';

import { CopyIcon } from '@/assets/icons';
import { copyToClipboard } from '@/utils/clipboard';

interface CopyButtonProps {
  text: string;
  successMessage?: string;
  className?: string;
  children?: ReactNode;
  showTooltip?: boolean;
}

/**
 * A reusable button component for copying text to clipboard
 */
export const CopyButton = ({
  text,
  successMessage = 'Copied!',
  className = '',
  children,
  showTooltip = true,
}: CopyButtonProps) => {
  const handleCopy = () => {
    copyToClipboard(text, successMessage);
  };

  return (
    <div className={`group relative ${className}`}>
      <button
        onClick={handleCopy}
        className="hover:opacity-80 focus:outline-none"
        title="Copy to clipboard"
        aria-label="Copy to clipboard"
      >
        {children || <img src={CopyIcon} alt="Copy" className="size-5" />}
      </button>

      {showTooltip && (
        <div className="absolute right-0 top-0 z-10 hidden h-[25px] w-[120px] translate-x-[45px] translate-y-[-30px] items-start justify-center gap-1 rounded-lg border border-[#d9d9d9] bg-white p-1.5 shadow after:absolute after:left-1/2 after:top-full after:size-0 after:-translate-x-1/2 after:border-8 after:border-solid after:border-transparent after:border-t-white after:drop-shadow-[0_1px_0_rgba(217,217,217,1)] after:content-[''] group-hover:inline-block">
          <div className="text-center font-['Inter'] text-xs font-medium leading-none text-black">
            Copy to clipboard
          </div>
        </div>
      )}
    </div>
  );
};
